import { ApiClient, ApiError, NetworkError, endpoints, errorMessage as baseErrorMessage } from "@baze/api-client";
import { t } from "@/i18n/id";

type Handler = () => void;
let sessionExpiredHandler: Handler | null = null;

/** Registered by the AuthProvider: clears state and routes to /masuk?redirect=… */
export function onSessionExpired(handler: Handler | null) {
  sessionExpiredHandler = handler;
}

export const client = new ApiClient({
  baseUrl: import.meta.env.VITE_API_BASE ?? "/api/v1",
  onSessionExpired: () => {
    if (sessionExpiredHandler) sessionExpiredHandler();
    else {
      const here = window.location.pathname + window.location.search;
      window.location.assign(`/masuk?redirect=${encodeURIComponent(here)}`);
    }
  },
});

export const api = endpoints(client);
export type Api = typeof api;

export { ApiError, NetworkError };

/** Human Indonesian message for any error (toasts, inline alerts). */
export function errorMessage(err: unknown): string {
  if (err instanceof ApiError && err.code === "rate_limited") return t.errors.rateLimited(err.retryAfter);
  return baseErrorMessage(err);
}

export function isApiError(err: unknown, code?: string): err is ApiError {
  return err instanceof ApiError && (code === undefined || err.code === code);
}

export function isNotFound(err: unknown): boolean {
  return err instanceof ApiError && (err.status === 404 || err.code === "not_found");
}

/** Errors worth retrying automatically (network blips, 5xx). Never 4xx. */
export function isTransient(err: unknown): boolean {
  if (err instanceof NetworkError) return true;
  return err instanceof ApiError && err.status >= 500;
}
